import { createApp } from 'vue'
import App from './App.vue'
import Map from './components/Map.vue'
import EditMap from './components/EditMap.vue'
import Login from './components/Login.vue'
// import NotFoundComponent from './components/NotFoundComponent.vue'
import { createRouter, createWebHistory } from 'vue-router'


const routes = [
  { path: '/map', component: Map },
  { path: '/map/admin', component: EditMap },
  { path: '/map/login', component: Login },
  // { path: '/map/:pathMatch(.*)', component: NotFoundComponent },
]

const router = createRouter({
  history: createWebHistory(),
  routes, // short for `routes: routes`
})

const app = createApp(App)
app.use(router)
app.mount('#app')
